import { secondsSinceEpoch } from '@Helpers/util';
import {
  PRODUCT_OVERVIEW_ACCESS_DATA_LOADED,
  PRODUCT_OVERVIEW_ACCESS_DATA_CLEAR,
  PRODUCT_REPORT_ACCESS_DATA_LOADED,
  PRODUCT_REPORT_ACCESS_DATA_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import { getAbortControllerSignal } from '../aborterHelper';
import { setFetchLoaderLoading, setFetchLoaderReset } from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';
import { setFaviconLoading, setFaviconDefault } from '../faviconActions';

// API helper
async function makeDomoRequest(method, path, body, authorization) {
  const signal = getAbortControllerSignal();
  const options = {
    method,
    signal,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: authorization,
    },
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(`https://api.domo.com/${path}`, options);

  if (!response.ok) {
    const json = await response.json();
    const formattedMessage = api.formatJsonError(json.error);
    throw new Error(formattedMessage);
  }

  return response;
}

// Reducer corresponding actions
function embedAccessDataLoaded(accessData) {
  return {
    type: PRODUCT_OVERVIEW_ACCESS_DATA_LOADED,
    payload: { accessData },
  };
}

function embedAccessDataClear() {
  return { type: PRODUCT_OVERVIEW_ACCESS_DATA_CLEAR };
}

function reportAccessDataLoaded(accessData) {
  return {
    type: PRODUCT_REPORT_ACCESS_DATA_LOADED,
    payload: { accessData },
  };
}

function reportAccessDataClear() {
  return { type: PRODUCT_REPORT_ACCESS_DATA_CLEAR };
}

// API
async function accessDataApi() {
  const authorization = `Basic ${process.env.DOMO_ENCODED_KEY}`;
  const response = await makeDomoRequest('GET', 'oauth/token?grant_type=client_credentials', null, authorization);

  return response.json();
}

// Helper
async function fetchEmbedAccessData(dispatch) {
  try {
    const response = await accessDataApi();

    dispatch(setFaviconDefault());
    dispatch(setFetchLoaderReset());
    dispatch(embedAccessDataLoaded(response));
  } catch (e) {
    if (e.name !== 'AbortError') {
      dispatch(setFaviconDefault());
      dispatch(arriveNotice(e.message));
    }
  }
}

async function fetchReportAccessData(dispatch) {
  try {
    const response = await accessDataApi();

    dispatch(setFaviconDefault());
    dispatch(setFetchLoaderReset());
    dispatch(reportAccessDataLoaded(response));
  } catch (e) {
    if (e.name !== 'AbortError') {
      dispatch(setFaviconDefault());
      dispatch(arriveNotice(e.message));
    }
  }
}

// Public components actions
export function refreshEmbedAccessDataRequest() {
  return async (dispatch, getState) => {
    const {
      productEmbed: { embedAccessToken, embedAccessTokenExpiration },
      fetchLoader: { dataLoading },
    } = getState();

    if (embedAccessToken && embedAccessTokenExpiration
      && embedAccessTokenExpiration - 60 > secondsSinceEpoch()) {
      return;
    }

    dispatch(embedAccessDataClear());
    dispatch(setFaviconLoading());
    if (!dataLoading) dispatch(setFetchLoaderLoading());

    await fetchEmbedAccessData(dispatch);
  };
}

export function clearEmbedAccessDataRequest() {
  return (dispatch) => {
    dispatch(embedAccessDataClear());
  };
}

export function refreshReportAccessDataRequest() {
  return async (dispatch, getState) => {
    const {
      productEmbed: { reportAccessToken, reportAccessTokenExpiration },
    } = getState();

    if (reportAccessToken && reportAccessTokenExpiration
      && reportAccessTokenExpiration - 60 > secondsSinceEpoch()) {
      return;
    }

    dispatch(reportAccessDataClear());
    dispatch(setFaviconLoading());

    await fetchReportAccessData(dispatch);
  };
}

export function clearReportAccessDataRequest() {
  return (dispatch) => {
    dispatch(reportAccessDataClear());
  };
}
